module.exports = __webpack_public_path__ + "static/coverImage-bdeb87fecac127e8378eeeee28e72b15.jpg";